import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export const keys = {
    all: ["memo-auto-text"],
    memoAutoTexts: () => [
        ...keys.all,
        "memo-auto-text-list"
    ],
    memoAutoText: (
        customerID: number,
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        offline: boolean
    ) => [
            ...keys.memoAutoTexts(),
            {
                customerID,
                groupID,
                objectType,
                offline
            }
    ],
};
